var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Activar Factura Electrónica"),
          ]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            class: _vm.errors.fel ? "is-invalid" : "",
            attrs: { items: _vm.options, "hide-details": "" },
            model: {
              value: _vm.data.fel,
              callback: function ($$v) {
                _vm.$set(_vm.data, "fel", $$v)
              },
              expression: "data.fel",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.fel, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Tipo de Identificación"),
          ]),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "form-control form-control-sm",
            class: _vm.errors.identification_type ? "is-invalid" : "",
            attrs: { items: _vm.identifications, "hide-details": "" },
            model: {
              value: _vm.data.identification_type,
              callback: function ($$v) {
                _vm.$set(_vm.data, "identification_type", $$v)
              },
              expression: "data.identification_type",
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.identification_type, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Identificación"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: _vm.format,
                expression: "format",
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.identification,
                expression: "data.identification",
              },
            ],
            staticClass: "form-control form-control-sm",
            class: _vm.errors.identification ? "is-invalid" : "",
            attrs: { type: "text" },
            domProps: { value: _vm.data.identification },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "identification", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.identification, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Correo Electrónico de Factura Electrónica"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.email_fel,
                expression: "data.email_fel",
              },
            ],
            staticClass: "form-control form-control-sm",
            class: _vm.errors.email_fel ? "is-invalid" : "",
            attrs: { type: "email" },
            domProps: { value: _vm.data.email_fel },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "email_fel", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.email_fel, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "div",
        { staticClass: "form-group mb-2" },
        [
          _c("small", { staticClass: "input-title" }, [
            _vm._v("Código de Actividad"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.data.activity_code_fel,
                expression: "data.activity_code_fel",
              },
              {
                name: "mask",
                rawName: "v-mask",
                value: "####.#",
                expression: "'####.#'",
              },
            ],
            staticClass: "form-control form-control-sm",
            class: _vm.errors.activity_code_fel ? "is-invalid" : "",
            attrs: { type: "text" },
            domProps: { value: _vm.data.activity_code_fel },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.data, "activity_code_fel", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.errors.activity_code_fel, function (error, index) {
            return _c(
              "small",
              { key: index, staticClass: "invalid-feedback" },
              [_vm._v(_vm._s(error))]
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }